import { Button } from "@blueprintjs/core";
import { FlexGrow, FlexRowStretch } from "../flex/Flex";

export const ViewHeader = (props: {
  open?: (o: boolean) => void;
  title: string;
  buttonText?: string;
}) => (
  <FlexRowStretch>
    <div>
      <h2>{props.title}</h2>
    </div>
    <FlexGrow />
    {props.buttonText && props.open ? (
      <div>
        <Button intent="success" icon="plus" onClick={() => props.open!(true)}>
          {props.buttonText}
        </Button>
      </div>
    ) : (
      <></>
    )}
  </FlexRowStretch>
);
